var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraOfflineIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 54,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.13861 10.7715L2.30059 6.25H22.3301L21.6102 10.7715H3.13861Z",
  fill: "#C7CED4",
  stroke: "#797979",
  strokeWidth: 0.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3959 11.9436C20.1289 13.8979 19.1629 15.6892 17.6768 16.9861C16.1907 18.283 14.2851 18.9976 12.3127 18.9976C10.3403 18.9976 8.43465 18.283 6.94854 16.9861C5.46244 15.6892 4.49649 13.8979 4.22949 11.9436H20.3959Z",
  fill: "#FF8266"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2438 11.0214C21.2432 11.2661 21.1456 11.5007 20.9723 11.6736C20.799 11.8465 20.5642 11.9436 20.3195 11.9436H4.4365C4.19192 11.9436 3.95735 11.8464 3.7844 11.6735C3.61144 11.5005 3.51428 11.266 3.51428 11.0214H21.2438Z",
  fill: "#FF8266"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M6 10.5H4.5L4 6.5H6.5L6 10.5Z",
  fill: "white"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.39,
  d: "M12.5189 17.6548C12.3539 17.9657 11.0129 17.898 10.721 17.8388C9.80435 17.669 8.92851 17.3259 8.14049 16.8278C7.34418 16.3239 6.65667 15.6658 6.11837 14.8924C5.82647 14.4841 5.33786 13.3927 5.51342 12.8364C5.67629 12.3943 6.50121 12.462 6.94117 12.4747C7.7386 12.498 8.34566 12.737 8.32028 13.7734C8.28432 15.2964 9.10501 16.1361 11.2689 16.7685C11.5988 16.8679 12.7516 17.2191 12.5189 17.6548Z",
  fill: "white"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5821 14.8578C15.5821 15.4419 15.4088 16.0129 15.0842 16.4985C14.7596 16.9842 14.2983 17.3626 13.7585 17.586C13.2188 17.8094 12.6249 17.8676 12.0521 17.7534C11.4792 17.6391 10.9531 17.3575 10.5403 16.9442C10.1275 16.5309 9.84664 16.0044 9.73315 15.4314C9.61965 14.8584 9.67867 14.2646 9.90274 13.7252C10.1268 13.1857 10.5058 12.7249 10.9919 12.4009C11.478 12.0769 12.0492 11.9044 12.6333 11.9052C13.0209 11.9052 13.4046 11.9816 13.7627 12.13C14.1207 12.2784 14.4459 12.496 14.7198 12.7702C14.9936 13.0444 15.2108 13.3699 15.3587 13.7281C15.5067 14.0863 15.5826 14.4702 15.5821 14.8578Z",
  fill: "#DB3D3D"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.48,
  d: "M13.22 14.264C13.2206 14.4972 13.1522 14.7253 13.0234 14.9197C12.8946 15.114 12.7111 15.2659 12.4961 15.3562C12.2812 15.4465 12.0443 15.4711 11.8153 15.4269C11.5864 15.3827 11.3756 15.2718 11.2096 15.1081C11.0436 14.9443 10.9298 14.7351 10.8825 14.5068C10.8352 14.2785 10.8565 14.0413 10.9438 13.825C11.0311 13.6088 11.1804 13.4233 11.373 13.2918C11.5656 13.1603 11.7927 13.0888 12.0259 13.0862C12.1817 13.0849 12.3362 13.1144 12.4806 13.1729C12.625 13.2315 12.7564 13.3179 12.8674 13.4273C12.9783 13.5367 13.0665 13.667 13.127 13.8105C13.1876 13.9541 13.2191 14.1082 13.22 14.264Z",
  fill: "#410909"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.43
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6231 6.00842L21.8236 11.0299H21.244C21.2434 11.2747 21.1458 11.5092 20.9725 11.6821C20.7992 11.855 20.5645 11.9521 20.3197 11.9521H20.3958C20.1266 13.9051 19.1597 15.6946 17.6737 16.9901C16.1876 18.2856 14.283 18.9995 12.3116 18.9999C11.9393 18.9996 11.5676 18.9735 11.199 18.9216C16.2564 17.9846 17.6778 15.567 18.1791 11.9521H18.1051C18.3497 11.9521 18.5842 11.8549 18.7572 11.682C18.9301 11.509 19.0273 11.2745 19.0273 11.0299H19.6069L19.996 6.00842H22.6231Z",
  fill: "#808080"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraOfflineIcon);
export default ForwardRef;